import { render } from "./TextsForm.vue?vue&type=template&id=7b4a48fa&scoped=true"
import script from "./TextsForm.vue?vue&type=script&lang=ts"
export * from "./TextsForm.vue?vue&type=script&lang=ts"

import "./TextsForm.vue?vue&type=style&index=0&id=7b4a48fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b4a48fa"

export default script